import React from 'react';
import { ChevronLeft, ExternalLink } from 'lucide-react';

/**
 * WorkflowHeader: top bar with workflow name, back button, and source badge.
 *
 * Props:
 *   workflow: { id, name, source: { type, conductorName, conductorVersion, discoveredWorkflowId } }
 *   onBack: callback to navigate back
 */
export const WorkflowHeader = ({ workflow, onBack }) => {
  if (!workflow) {
    return (
      <div className="border-b border-gray-200 bg-white p-4">
        <div className="flex items-center gap-2">
          <button onClick={onBack} className="p-1 hover:bg-gray-100 rounded">
            <ChevronLeft size={20} />
          </button>
          <div className="h-8 bg-gray-200 rounded w-48 animate-pulse"></div>
        </div>
      </div>
    );
  }

  const { source } = workflow;
  const sourceLabel = source?.conductorName
    ? `Converted from Conductor: ${source.conductorName} v${source.conductorVersion}`
    : 'Native Workflow';

  return (
    <div className="border-b border-gray-200 bg-white p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <button
            onClick={onBack}
            className="p-1 hover:bg-gray-100 rounded transition"
            title="Go back"
          >
            <ChevronLeft size={20} className="text-gray-600" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{workflow.name}</h1>
            <p className="text-sm text-gray-600 mt-1">{workflow.description}</p>
          </div>
        </div>
        {source && (
          <div className="flex items-center gap-2 bg-blue-50 px-4 py-2 rounded-lg border border-blue-200">
            <span className="text-xs font-medium text-blue-900">{sourceLabel}</span>
            {source.discoveredWorkflowId && (
              <a
                href={`/workflow-discovery?filter=${source.discoveredWorkflowId}`}
                className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800"
                title="View source workflow"
              >
                <ExternalLink size={14} />
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
